import { Icon, IIcons } from "@/assets/icons";
import { cn } from "@/utils";
import React, { useEffect, useRef, useState } from "react";

interface ButtonIconProps extends React.ButtonHTMLAttributes<HTMLDivElement> {
  name: IIcons;
  hoverColor?: string;
  className?: string;
  iconClassName?: string;
  forceActive?: boolean;
}

export const ButtonIcon: React.FC<ButtonIconProps> = ({
  name,
  hoverColor = "var(--cyan)",
  className,
  iconClassName,
  forceActive,
  ...props
}) => {
  const refButton = useRef<HTMLDivElement>(null);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    // handle hover effect
    const button = refButton.current;
    if (!button) return;

    const handleMouseEnter = () => {
      setIsHovered(true);
    };

    const handleMouseLeave = () => {
      setIsHovered(false);
    };

    button.addEventListener("mouseenter", handleMouseEnter);
    button.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      button.removeEventListener("mouseenter", handleMouseEnter);
      button.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, [refButton]);

  return (
    <div
      ref={refButton}
      className={cn("p-[2px] rounded cursor-pointer w-fit", className)}
      {...props}
    >
      <Icon
        name={name}
        color={forceActive || isHovered ? hoverColor : undefined}
        className={iconClassName}
      />
    </div>
  );
};
